module.exports = __webpack_public_path__ + "static/media/cssda-ux-Lukasz-Macon_08_12_2021.83537eb9.pdf";